export function objectToURIComponent(data) {
    return Object.keys(data).filter(function (analyticsKey) {
        return data[analyticsKey];
    }).map(function (analyticsKey) {
        return analyticsKey + '=' + encodeURIComponent(data[analyticsKey]);
    }).join('&');
}
